import axios from 'axios'

export const getFileNameFromContentDisposition = (
  contentDisposition: string | undefined,
  fallback: string
): string => {
  if (!contentDisposition) return fallback

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)

  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1])
  }

  const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i)

  if (filenameMatch?.[1]) {
    return filenameMatch[1]
  }

  return fallback
}

export const downloadBlobFile = (blob: Blob, fileName: string): void => {
  if (typeof window === 'undefined') return

  const url = window.URL.createObjectURL(blob)

  const element = document.createElement('a')

  element.setAttribute('href', url)

  element.setAttribute('download', fileName)

  element.style.display = 'none'

  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)

  window.URL.revokeObjectURL(url)
}

export const getFileNameFromUrl = (url: string, fallback: string): string => {
  try {
    const fileName = new URL(url).pathname.split('/').pop()

    if (fileName) {
      return decodeURIComponent(fileName)
    }
  } catch {
    return fallback
  }

  return fallback
}

const INVALID_FILE_NAME_CHARS = /[/\\:*?"<>|]/g

export const getTermDownloadFileName = (termTitle: string, fallback: string): string => {
  const sanitizedTitle = termTitle.trim().replace(INVALID_FILE_NAME_CHARS, '-').replace(/\s+/g, ' ')

  if (!sanitizedTitle) {
    return fallback.endsWith('.zip') ? fallback : `${fallback}.zip`
  }

  return sanitizedTitle.endsWith('.zip') ? sanitizedTitle : `${sanitizedTitle}.zip`
}

export const downloadFileFromUrl = async (url: string, fileName: string): Promise<void> => {
  if (!url || typeof window === 'undefined') return

  const { data: blob } = await axios.get<Blob>(url, { responseType: 'blob' })

  downloadBlobFile(blob, fileName)
}
